export default __webpack_public_path__ + "static/media/Loader.90672f1d.gif";